import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';
export const componentKey = "SIGN_UP";

const initialSignUpFormFields = {
    firstName : "",
    lastName : "",
    email: "",
    password: "",
    confirmPassword: "",
    enableAPI: false,
    agreeTerms: false,
    isReceiveCompliance: true,
    GRecaptchaResponse: "",
}

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setSignUpFormFields: (state, action) => {
            state.signUpFormFields = {
                ...state.signUpFormFields,
                ...action.payload,
            }
        },
        setSignUpFormErrors: (state, action) => {
            state.signUpFormErrors = {
                ...state.signUpFormErrors,
                ...action.payload,
            }
        },
        setEmailCanBeUsed: (state, action) => {
            state.emailCanBeUsed = action.payload;
        },
        resetSignUpPage: (state, action) => {
            state.signUpFormFields = initialSignUpFormFields;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },
        setSignedUpUserData: (state, action)=>{
            state.signedUpUserData = action.payload
        }
    }, 
    initialReducerState: {
        signUpFormFields : initialSignUpFormFields,
        signUpFormErrors : {
            emailErrorStatus: false,
            emailErrorMessage: "",
            signUpErrorStatus: false,
            signUpErrorMessage: "",
        },
        emailCanBeUsed: false,
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        signedUpUserData: {}
    }
});
export const { setSignUpFormFields, setSignUpFormErrors, setEmailCanBeUsed, resetSignUpPage, setLoadingState, setSignedUpUserData } = actions;
